var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyBarchartDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 47.41,
    viewBox: "0 0 55 47.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30719",
    "data-name": "Group 30719",
    transform: "translate(-400 -293.795)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "graph_2_",
    "data-name": "graph (2)",
    d: "M62.03,13.5H53.12a2.958,2.958,0,0,0-2.97,2.97V57.94a2.958,2.958,0,0,0,2.97,2.97h8.91A2.958,2.958,0,0,0,65,57.94V16.36A2.936,2.936,0,0,0,62.03,13.5Z",
    transform: "translate(390 280.295)",
    fill: "#827ca0",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "graph_2_2",
    "data-name": "graph (2)",
    d: "M42.01,30H33.1a2.958,2.958,0,0,0-2.97,2.97V57.94a2.958,2.958,0,0,0,2.97,2.97h8.91a2.958,2.958,0,0,0,2.97-2.97V32.97A3.107,3.107,0,0,0,42.01,30Z",
    transform: "translate(390 280.295)",
    fill: "#827ca0",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "graph_2_3",
    "data-name": "graph (2)",
    d: "M21.88,36.93H12.97A2.958,2.958,0,0,0,10,39.9V57.94a2.958,2.958,0,0,0,2.97,2.97h8.91a2.958,2.958,0,0,0,2.97-2.97V39.9A2.958,2.958,0,0,0,21.88,36.93Z",
    transform: "translate(390 280.295)",
    fill: "#827ca0",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBarchartDark);
export default __webpack_public_path__ + "static/media/Empty-barchartDark.12e5d2c8c300ae505d66a3268992eeed.svg";
export { ForwardRef as ReactComponent };